if (!customElements.get('scroll-position')) {
  customElements.define(
    'scroll-position',
    class ScrollPosition extends window.BAO.CustomElement {
      connectedCallback () {
        super.connectedCallback()

        this.isTicking = false
        this.lastKnownY = window.scrollY

        this.requestTick = this.requestTick.bind(this)
        this.updateEl = this.updateEl.bind(this)
        this.setPercentage = this.setPercentage.bind(this)

        this.updateEl()
      }

      setupListeners () {
        super.setupListeners()

        this.onScroll = this.onScroll.bind(this)

        window.addEventListener('scroll', this.onScroll, { passive: true })
      }

      onScroll () {
        this.lastKnownY = window.scrollY

        this.requestTick()
      }

      requestTick () {
        if (!this.isTicking) requestAnimationFrame(this.updateEl)

        this.isTicking = true
      }

      updateEl () {
        this.isTicking = false

        this.setPercentage()
      }

      setPercentage () {
        const bodyHeight = window.innerHeight - document.body.offsetHeight
        const scrollPercentage = parseInt((-this.lastKnownY / bodyHeight) * 100)

        this.els.value.element.innerText = `${Math.max(
          0,
          Math.min(100, scrollPercentage)
        )}%`
        this.els.value.element.style.top = `${scrollPercentage}%`
      }
    }
  )
}
